export const APPLICATIONS = {
  CORE: "core",
  ADMIN: "APP00",
  GROUP: "APP01",
  INDIVIDUAL: "APP02",
  COMMON: "APP03",
  WC: "APP04"
};
